export function Copyright() {
  return (
    <p className="text-sm text-gray-500">
      © {new Date().getFullYear()} Enluma Consult+. All rights reserved.
    </p>
  );
}
